import type { DonutSegment } from '@dashboard/types/analytics.types'
import { buildDonutSegments } from '@dashboard/utils/svgHelpers'
import cn from '@integrations/classnames'
import styles from './DonutChart.module.scss'

interface Props {
  segments: DonutSegment[]
  innerLabel?: string
  innerCaption?: string
}

function DonutChart({ segments, innerLabel, innerCaption }: Props) {
  const computed = buildDonutSegments(segments)

  return (
    <svg className={cn('w-full h-full')} viewBox='0 0 40 40'>
      {/* Circles rotated so segments start at 12 o'clock */}
      <g transform='rotate(-90, 20, 20)'>
        <circle cx='20' cy='20' r='15.9155' fill='none' stroke='var(--chart-track)' strokeWidth='5' />
        {computed.map((seg) => (
          <circle
            key={seg.label}
            cx='20'
            cy='20'
            r='15.9155'
            fill='none'
            stroke={seg.color}
            strokeWidth='5'
            strokeDasharray={seg.strokeDasharray}
            strokeDashoffset={seg.strokeDashoffset}
          />
        ))}
      </g>

      {innerLabel && (
        <text
          x='20'
          y={innerCaption ? '18.5' : '20'}
          textAnchor='middle'
          dominantBaseline='middle'
          className={cn(styles['donut-chart-label'], 'donut-chart-label')}
          fontWeight='500'
          fill='var(--dash-text-primary)'
        >
          {innerLabel}
        </text>
      )}

      {innerCaption && (
        <text
          x='20'
          y='25'
          textAnchor='middle'
          dominantBaseline='middle'
          className={cn(styles['donut-chart-caption'], 'donut-chart-caption')}
          fill='var(--text-secondary)'
        >
          {innerCaption}
        </text>
      )}
    </svg>
  )
}

export default DonutChart
